import {publicRoutes as manifest} from '@tenant/core/routes';
import resolveWebRoutes from './resolve';

/**
 * Public (marketing and legal) web routes.
 *
 * @returns {object[]}
 */
const publicRoutes = () => resolveWebRoutes(manifest(), {authenticated: false});

export default publicRoutes;
